import { ORG_FEATURES } from "@/src/constants/org-features";
import { useOrgFeatures } from "@/src/services/organization/org-features.hooks";
import React from "react";
import { useTranslation } from "react-i18next";
import { Text, View } from "react-native";
import Toast from "react-native-toast-message";
import SectionHeader from "../../ui-kit/section-header";
import Toggle from "../../ui-kit/toggle";

/**
 * Settings → Organization: the org admin switches optional features on or off
 * for the whole organization. Every feature starts off; see `ORG_FEATURES`.
 */
const Organization = () => {
  const { t } = useTranslation();
  const { isEnabled, isLoading, isError, setFeature, savingKey } =
    useOrgFeatures();

  const handleToggle = async (
    key: (typeof ORG_FEATURES)[number]["key"],
    on: boolean,
  ) => {
    try {
      await setFeature({ key, on });
    } catch {
      Toast.show({ type: "error", text1: t("ERROR_ORG_FEATURE_SAVE_FAILED") });
    }
  };

  return (
    <View className="gap-6">
      <SectionHeader
        title={t("LABEL_ORG_FEATURES")}
        subtitle={t("LABEL_ORG_FEATURES_DESC")}
      />

      {isError && (
        <Text className="text-sm text-slate">
          {t("ERROR_ORG_FEATURES_LOAD_FAILED")}
        </Text>
      )}

      {ORG_FEATURES.map((feature) => (
        <View
          key={feature.key}
          className="flex-row justify-between items-start"
        >
          <View className="flex-1 pr-4">
            <SectionHeader
              title={t(feature.labelKey)}
              subtitle={t(feature.descriptionKey)}
            />
          </View>
          <Toggle
            value={isEnabled(feature.key)}
            onChange={(on) => handleToggle(feature.key, on)}
            disabled={isLoading || isError || savingKey !== undefined}
          />
        </View>
      ))}
    </View>
  );
};

export default Organization;
